import { defineStore } from 'pinia'
import axios from 'axios'
import { ref, reactive } from 'vue'
import { useLocalizationStore } from './LocalizationStore.js'
import { useRoute, useRouter } from 'vue-router'
import Swal from 'sweetalert2'

export const useBusinessStore = defineStore('BusinessClients', {
    state: () => {
        return {
            business: reactive({
                recurly: {
                    webhook_url: null,
                    webhook_secret_key: null,
                    api_key: null
                },
                brevo: {
                    api_key: null,
                    email: null,
                },
                count: 0,
                detail_status: {},
                setting_status: {}
            }),
            localizationStore: useLocalizationStore(),
            route: useRoute(),
            router: useRouter(),
            clientstatus:reactive({}),
            clickedBusinessDetails:ref(false),
            isLoading : ref(true),
            clientDetailTab: ref(1),
            tutorials: {
                recurly: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/Client%20Billing.mp4',
                accessToken: 'https://www.youtube.com/embed/S9Nh74gfUTk?si=C_vEzVdu83PfWVpd',
                apiSetting: 'https://www.youtube.com/embed/Fjd8Zju5ZwM?si=3EFKzhWjSOql0tVJ',
                clickSendFaxSetting: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/click-send-fax-setup.mp4',
                emailSetting: 'https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/CreditfixrrBizTutorials/brevo-email-setup.mp4',
            }
        }
    },
    persist: {
        paths: ['clientDetailTab'],
        debug: false
    },
    actions: {
        async fetchBusiness() {
            try {
                const $this = this;
                const route = this.router.resolve(
                    {
                        name: 'company',
                    }
                );
                this.business = await axios.post(route.href)
                .then(function (response) {
                    $this.business.brevo.api_key = response.data.data.brevo.api_key;
                    $this.business.brevo.email = response.data.data.brevo.email;
                    return response.data.data;
                });
            } catch (error) {
                // console.log(error);
            }
        },
        saveSettings() {
            const route = this.router.resolve(
                {
                    name: 'company-recurly-setting-update',
                }
            );
            axios.put(
                route.href,
                _.pick(this.business.recurly, ['api_key', 'webhook_secret_key'])
            )
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
            })
            .catch(function (error) {
                toastr.error(error.message, 'Error!');
            });
        }
    },
    getters: {
    },
})

